// extracted by mini-css-extract-plugin
module.exports = {"story-meta-data":"storyMetaData-m__story-meta-data__2E2m1","comments":"storyMetaData-m__comments__1NCEW","tag-name":"storyMetaData-m__tag-name__23iTK"};